module.exports = __webpack_public_path__ + "img/215.f1be3028.jpg";